import { useEffect, useState } from 'react';
import { FieldConfig } from '../custom-table.type';
import { getHeaderSortOrder, toggleSorting } from './custom-table-sorting.business';
import { CustomTableSortingProps, CustomTableSortItems } from './custom-table-sorting.model';

interface UseCustomTableSorting<T> {
    fieldsToShow: FieldConfig<T>[];
    sortingProps?: CustomTableSortingProps;
}

export const useCustomTableSorting = <T>({ fieldsToShow, sortingProps }: UseCustomTableSorting<T>) => {
    const [headerSortOrder, setHeaderSortOrder] = useState<CustomTableSortItems>({});
    const { defaultSort: defaultSorting, onSortOrderChange: onSortChange } = sortingProps || {};

    const handleSortOrderChange = (field: string) => {
        const nextOrder = toggleSorting(headerSortOrder[field] ?? 'default');
        setHeaderSortOrder((prevOrder) => {
            const newSorting = Object.keys(prevOrder).reduce((newOrder, column) => {
                newOrder[column] = column === field ? nextOrder : 'default';
                return newOrder;
            }, {} as CustomTableSortItems);
            onSortChange?.(newSorting);
            return newSorting;
        });
    };

    useEffect(() => {
        if (fieldsToShow.length > 0) {
            setHeaderSortOrder(getHeaderSortOrder(fieldsToShow, headerSortOrder, defaultSorting));
        }
    }, [fieldsToShow]);

    useEffect(() => {
        if (fieldsToShow.length > 0) {
            setHeaderSortOrder(getHeaderSortOrder(fieldsToShow, {}, defaultSorting));
        }
    }, [defaultSorting]);

    return {
        headerSortOrder,
        handleSortOrderChange,
    };
};
